"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.MainImageWrapper = exports.ImageWrapper = exports.ImagePicture = exports.ImageCaption = exports.Image = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject, _templateObject2, _templateObject3;

var MainImageWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Gallerystyles__MainImageWrapper",
  componentId: "sc-1pavv3i-0"
})(["width:100%;justify-content:center;text-align:center;& > div.video-player{max-width:500px;margin:0 auto;}"]);

exports.MainImageWrapper = MainImageWrapper;

var ImageWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Gallerystyles__ImageWrapper",
  componentId: "sc-1pavv3i-1"
})(["", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["", ""])), function (_ref) {
  var _theme$gallery, _theme$gallery$image;

  var theme = _ref.theme;
  return theme === null || theme === void 0 ? void 0 : (_theme$gallery = theme.gallery) === null || _theme$gallery === void 0 ? void 0 : (_theme$gallery$image = _theme$gallery.image) === null || _theme$gallery$image === void 0 ? void 0 : _theme$gallery$image.wrapper;
}));

exports.ImageWrapper = ImageWrapper;

var ImagePicture = _styledComponents["default"].picture.withConfig({
  displayName: "Gallerystyles__ImagePicture",
  componentId: "sc-1pavv3i-2"
})(["", ""], (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["", ""])), function (_ref2) {
  var _theme$gallery2, _theme$gallery2$image;

  var theme = _ref2.theme;
  return theme === null || theme === void 0 ? void 0 : (_theme$gallery2 = theme.gallery) === null || _theme$gallery2 === void 0 ? void 0 : (_theme$gallery2$image = _theme$gallery2.image) === null || _theme$gallery2$image === void 0 ? void 0 : _theme$gallery2$image.picture;
}));

exports.ImagePicture = ImagePicture;

var Image = _styledComponents["default"].img.withConfig({
  displayName: "Gallerystyles__Image",
  componentId: "sc-1pavv3i-3"
})(["", " margin-left:auto;margin-right:auto;"], (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["", ""])), function (_ref3) {
  var _theme$gallery3, _theme$gallery3$image;

  var theme = _ref3.theme;
  return theme === null || theme === void 0 ? void 0 : (_theme$gallery3 = theme.gallery) === null || _theme$gallery3 === void 0 ? void 0 : (_theme$gallery3$image = _theme$gallery3.image) === null || _theme$gallery3$image === void 0 ? void 0 : _theme$gallery3$image.img;
}));

exports.Image = Image;

var ImageCaption = _styledComponents["default"].div.withConfig({
  displayName: "Gallerystyles__ImageCaption",
  componentId: "sc-1pavv3i-4"
})(["", ""], function (_ref4) {
  var _theme$gallery4;

  var theme = _ref4.theme;
  return theme === null || theme === void 0 ? void 0 : (_theme$gallery4 = theme.gallery) === null || _theme$gallery4 === void 0 ? void 0 : _theme$gallery4.caption;
});

exports.ImageCaption = ImageCaption;

var Root = _styledComponents["default"].div.withConfig({
  displayName: "Gallerystyles__Root",
  componentId: "sc-1pavv3i-5"
})(["display:flex;flex-direction:column;justify-content:center;"]);

exports.Root = Root;